<template>
  <div data-app>
    <div class="row mt-1 mx-0 new_list_st_by_ch">
      <div class="row m-0 col-12 p-4 bg-white border-r-16">
        <div class="col-md-4 p-0">
          <span class="leatext_job_heading_by_new_home">Job applications</span>
        </div>
        <div class="col-8 p-0">
          <button
            style="
              margin-left: 12px;
              width: 142px;
              height: 34px;
              border: 1px solid #35a2e5;
              border-radius: 8px;
              font-weight: 400;
              font-size: 13px;
              text-align: center;
              color: #35a2e5;
              float: right;
            "
            @click="clearFilter()"
          >
            Clear Filtter
          </button>
        </div>
      </div>
      <div class="row m-0 col-8 py-0 pl-0" style="height: fit-content">
        <div class="col-md-12 py-5 row m-0 pr-0">
          <div class="col-md-4 d-flex filter_by_ch py-0 pl-0">
            <v-combobox
              v-model="filter_jobsekeer"
              style="width: 30px"
              :items="job_jobsekeer"
              label="Search company by name"
              @change="filterbyjobsekeer"
            >
              <template>
                <v-chip
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
            </v-combobox>
          </div>
          <div class="col-md-2 p-0 m-0"></div>
          <div class="col-md-3 d-flex filter_by_ch py-0">
            <v-combobox
              v-model="filter_tital"
              style="width: 30px"
              :items="job_titals"
              label="Filter by Job vacancy"
              @change="filtertital"
            >
              <template>
                <v-chip
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
            </v-combobox>
          </div>
          <div class="col-md-3 pl-0 d-flex filter_by_ch py-0">
            <v-select
              v-model="filter"
              style="width: 30px"
              :items="statusItems"
              label="Filter by applicant status"
              @change="filterData"
            ></v-select>
          </div>
        </div>
        <!-- //////////////////////////////////start -->
        <div
          class="col-md-4 row m-0 pt-0 pr-0"
          v-for="(item, index) in data"
          :key="index"
        >
          <div
            class="col-md-12 row m-0 border-r-16"
            v-if="item.job != null"
            :id="
              'jobseeker_app_' +
                item.recruiter_profile.company_name
                  .toLowerCase()
                  .replace(/ /g, '-')
                  .replace(/[^\w-]+/g, '') +
                '_' +
                item.job.job_title
                  .toLowerCase()
                  .replace(/ /g, '-')
                  .replace(/[^\w-]+/g, '')
            "
            :class="
              detail1 && detail1.id === item.id
                ? 'bg-info-new'
                : 'bg-white' && detail2 && detail2.id === item.id
                ? 'bg-info-new'
                : 'bg-white' && detail3 && detail3.id === item.id
                ? 'bg-info-new'
                : 'bg-white' && detail4 && detail4.id === item.id
                ? 'bg-info-new'
                : 'bg-white' && detail5 && detail5.id === item.id
                ? 'bg-info-new'
                : 'bg-white'
            "
          >
            <!-- <div class="col-md-12 p-0">
              <v-checkbox
                class="p-0 m-0"
                color="secondary"
                hide-details
                @change="
                  bulkAction($event, item)"
              ></v-checkbox>
            </div> -->
            <div class="col-md-4 p-0" style="position: relative">
              <!-- :src="mediaUrl + item.recruiter_profile.profile_pic" -->
              <img
                @error="onImageLoadFailure($event)"
                :src="mediaUrl + item.recruiter_profile.profile_pic || ''"
                alt="Profile Image"
                id="img_profile"
                style="width: 74px; height: 74px; border-radius: 50%"
                class="circular--square"
              />
              <!-- <v-btn
                icon
                :style="item.favorite == 'yes' && 'color: orange'"
                @click="favoriteClick(item.id)"
                class="style_madi_star_n shadow"
              >
                <v-icon>mdi-star</v-icon>
              </v-btn> -->
            </div>
            <div class="col-md-8 p-0">
              <div
                style="
                  border: 1.5px solid rgb(53, 162, 229);
                  font-size: 12px;
                  padding: 2px 16px;
                  border-radius: 4px;
                  color: rgb(53, 162, 229);
                  width: fit-content;
                  position: absolute;
                  right: 0px;
                  top: 20px;
                  text-align: center;
                  background-color: transparent;
                "
              >
                {{ item.status }}
              </div>
            </div>
            <div class="col-md-12 p-0">
              <span
                class="label label-info"
                style="
                  margin: 13px 0 8px 0;
                  background: #e80000;
                  width: auto !important;
                  padding: 0 8px !important;
                  border-radius: 16px !important;
                  font-size: 14px;
                "
                v-if="
                  item.notification ? item.notification.seen_at == null : ''
                "
                >new</span
              >
            </div>
            <div class="col-md-12 p-0 mt-4">
              <h4
                class="mb-0"
                style="color: #242424; font-size: 18px; font-weight: bold"
              >
                {{ item.recruiter_profile.company_name }}
              </h4>
            </div>
            <div class="col-md-12 p-0">
              <p class="m-0" style="color: #666; font-size: 14px">
                Applied for {{ item.job.job_title }}
              </p>
            </div>
            <div class="col-md-12 p-0">
              <p class="m-0" style="color: #666; font-size: 11px">
                applied:
                {{ moment(item.job.created_at).format("DD MMM, YY. hh:mmA") }}
              </p>
            </div>
            <hr
              class="col-md-12 p-0 mt-3"
              style="background: rgba(53, 162, 229, 0.25)"
            />
            <div
              class="my-0 mx-0 p-0 col-md-12 d-flex justify-content-center"
              style="gap: 5px"
            >
              <div class="p-0">
                <!-- {{item}} -->
                <button
                  v-on:click="singleDetail1(item)"
                  
                  type="button"
                  class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  "
                >
                  <img
                    class="dashbord25"
                    src="\images/job_application/Video_icon_.svg"
                    alt=""
                    width="25"
                    height="25"
                  />
                  <div class="light_frozi">Video</div>
                </button>
              </div>
              <div class="p-0">
                <button
                  v-on:click="singleDetail2(item)"
                  
                  type="button"
                  class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  "
                >
                  <img
                    class="dashbord25"
                    src="\images/job_application/Audio_icon_normal.svg"
                    alt=""
                    width="25"
                    height="25"
                  />
                  <div class="light_frozi">Audio</div>
                </button>
              </div>
              <div class="p-0">
                <button
                  v-on:click="singleDetail4(item)"
                  
                  type="button"
                  class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  "
                >
                  <img
                    class="dashbord25"
                    src="\images/job_application/Q&A_icon_normal.svg"
                    alt=""
                    width="25"
                    height="25"
                  />
                  <div class="light_frozi">Q/A</div>
                </button>
              </div>
              <div class="p-0">
                <button
                  v-on:click="
                    singleDetail3(item),
                      msg_notification_Bulk(item),
                      (item.msgs_counts = 0)
                  "
                 
                  type="button"
                  class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  "
                >
                  <img
                    class="dashbord25"
                    src="\images/job_application/Conversations_icon_normal.svg"
                    alt=""
                    width="25"
                    height="25"
                  />
                  <div class="light_frozi">Chat</div>
                  <span
                    class=""
                    style="
                      position: absolute;
                      top: -8px;
                      right: -15%;
                      background-color: #e80000 !important;
                      color: white !important;
                      border-radius: 50px;
                      width: 16px;
                      height: 16px;
                    "
                    v-if="item.msgs_counts > 0"
                    >{{ item.msgs_counts }}</span
                  >
                </button>
              </div>
              <div class="p-0">
                  <button v-on:click="singleDetail5(item)" type="button" class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  ">
                    <img class="dashbord25" src="\images/job_application/Notes.svg" alt="" width="25" height="25" />
                    <div class="light_frozi">Notes</div>
                  </button>
                </div>
            </div>
            <hr
              class="col-md-12 p-0 mt-3"
              style="background: rgba(53, 162, 229, 0.25)"
            />
            <div class="_btn_gridddd p-0 m-0">
              <div
                class="p-0"
                @click="
                  view_CV(item.cv_path)
                "
              >
                <button type="button" class="new_details_job_dashbord_list2">
                  <span class="v-btn__content">View CV</span>
                </button>
              </div>
              <div
                class="p-0"
                @click="
                  downloadCV(item.cv_path)
                "
                style=""
              >
                <button type="button" class="new_details_job_dashbord_list2">
                  <span class="v-btn__content">Download CV</span>
                </button>
              </div>
              <div
                class="p-0"
                @click="
                  askUserAboutDelete(item)
                "
              >
                <button
                  type="button"
                  class="new_details_job_dashbord_list2"
                  style="
                    background: rgba(147, 6, 6, 0.05) !important;
                    border-color: rgba(147, 6, 6, 0.5) !important;
                  "
                >
                  <img
                    class="dashbord"
                    src="\images/job_application/Delete.svg"
                    alt=""
                    width="16"
                    height="16"
                  />
                </button>
              </div>
            </div>
            <div v-if="item.id == iD_rout ? singleDetail1(item) : ''">
              <div
                class="col-12 p-0 pt-3 text-center"
                v-on:click="singleDetail1(item)"
               
                style="
                font-size: 13px;
                font-weight: bold;
                color: rgb(0, 86, 150);
                cursor: pointer;
              "
              >
                See Full details
              </div>
            </div>
            <div v-else>
              <div
                class="col-12 p-0 pt-3 text-center"
                v-on:click="singleDetail1(item)"
                
                style="
                font-size: 13px;
                font-weight: bold;
                color: rgb(0, 86, 150);
                cursor: pointer;
              "
              >
                See Full details
              </div>
            </div>
          </div>
        </div>
        <!-- ////////////////////////////////// -->
      </div>
      <div class="col-lg-4 p-0" v-if="detail1">
        <!-- {{detail1}} -->
        <div class="col-lg-12 pr-0 pl-0">
          <div class="col-md-12 row m-0 p-0">
            <div
              class="col-md-12 row m-0 border-t-lr-16 bg-info-new pb-0"
              :id="
                'jobseeker_app_' +
                  detail1.recruiter_profile.company_name
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '_' +
                  detail1.job.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
              "
            >
              <div class="col-md-12 p-0 text-end">
                <button
                  class="badge badge-danger badge-pill"
                  @click="(detail1 = false), (alwyes = true)"
                >
                  X
                </button>
              </div>
              <div class="col-md-4 p-0" style="position: relative">
                <img
                  @error="onImageLoadFailure($event)"
                  :src="mediaUrl + detail1.recruiter_profile.profile_pic || ''"
                  alt="Profile Image"
                  style="width: 74px; height: 74px; border-radius: 50%"
                />
                <!-- <v-btn
                  icon
                  :style="detail1.favorite == 'yes' && 'color: orange'"
                  @click="favoriteClick(detail1.id)"
                  class="style_madi_star_n shadow"
                >
                  <v-icon>mdi-star</v-icon>
                </v-btn> -->
              </div>
              <div class="col-md-8 p-0">
                <div
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 16px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                >
                  {{ detail1.status }}
                </div>
                <!-- <b-form-select
                  v-model="detail1.status"
                  :options="statusItems"
                  size="sm"
                  @change="bulkActionProceed_singel($event, detail1.id)"
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 26px 2px 2px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                ></b-form-select> -->
              </div>
              <div class="col-md-12 p-0 mt-5">
                <h4
                  class="mb-0"
                  style="color: #242424; font-size: 18px; font-weight: bold"
                >
                  {{ detail1.recruiter_profile.company_name }}
                </h4>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 14px">
                  Applied for {{ detail1.job.job_title }}
                </p>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 11px">
                  applied:
                  {{ moment(detail1.job.created_at).format("DD MMM, YY. hh:mmA") }}
                </p>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div class="_btn_gridddd p-0 m-0">
                <div class="p-0" @click="view_CV(detail1.cv_path)">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">View CV</span>
                  </button>
                </div>
                <div class="p-0" @click="downloadCV(detail1.cv_path)" style="">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">Download CV</span>
                  </button>
                </div>
                <div class="p-0" @click="askUserAboutDelete(detail1)">
                  <button
                    type="button"
                    class="new_details_job_dashbord_list2"
                    style="
                      background: rgba(147, 6, 6, 0.05) !important;
                      border-color: rgba(147, 6, 6, 0.5) !important;
                    "
                  >
                    <img
                      class="dashbord"
                      src="\images/job_application/Delete.svg"
                      alt=""
                      width="16"
                      height="16"
                    />
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div
                class="
                  mb-3
                  mt-0
                  mx-0
                  p-0
                  col-md-12
                  d-flex
                  justify-content-center
                "
                style="gap: 5px"
              >
                <div class="p-0">
                  <button
                    v-on:click="singleDetail11(detail1)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Video_icon_.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Video</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail22(detail1)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Audio_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Audio</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail4(detail1)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Q&A_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Q/A</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="
                      singleDetail3(detail1),
                        msg_notification_Bulk(detail1),
                        (detail1.msgs_counts = 0)
                    "
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Conversations_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Chat</div>
                    <span
                      class=""
                      style="
                        position: absolute;
                        top: -8px;
                        right: -15%;
                        background-color: #e80000 !important;
                        color: white !important;
                        border-radius: 50px;
                        width: 16px;
                        height: 16px;
                      "
                      v-if="detail1.msgs_counts > 0"
                      >{{ detail1.msgs_counts }}</span
                    >
                  </button>
                </div>
                <div class="p-0">
                  <button v-on:click="singleDetail5(detail1)" type="button" class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  ">
                    <img class="dashbord25" src="\images/job_application/Notes.svg" alt="" width="25" height="25" />
                    <div class="light_frozi">Notes</div>
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0"
                style="background: rgba(53, 162, 229, 0.25)"
              />
            </div>
          </div>
          <div
            class="
              col-md-12
              forvideoFullW
              row
              m-0
              border-b-lr-16
              bg-info-new
              pt-0
            "
          >
            <h5
              class="p-0 mb-4"
              style="
                font-size: 26px;
                color: #005696 !important;
                font-weight: bold;
              "
            >
              Video introduction
            </h5>
            <video-player
              class="video-player-box p-0 video_by_ch video_by_ch2"
              ref="videoPlayer"
              :options="detail1.videoPlayer"
              :playsinline="true"
              customEventName="customstatechangedeventname"
            >
            </video-player>
          </div>
        </div>
      </div>
      <div class="col-lg-4 p-0" v-if="detail2">
        <div class="col-lg-12 pl-0 pr-0">
          <div class="col-md-12 row m-0 p-0">
            <div
              class="col-md-12 row m-0 border-t-lr-16 bg-info-new pb-0"
              :id="
                'jobseeker_app_' +
                  detail2.recruiter_profile.company_name
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '_' +
                  detail2.job.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
              "
            >
              <div class="col-md-12 p-0 text-end">
                <button
                  class="badge badge-danger badge-pill"
                  @click="(detail2 = false), (alwyes = true)"
                >
                  X
                </button>
              </div>
              <div class="col-md-4 p-0" style="position: relative">
                <img
                  @error="onImageLoadFailure($event)"
                  :src="mediaUrl + detail2.recruiter_profile.profile_pic || ''"
                  alt="Profile Image"
                  style="width: 74px; height: 74px; border-radius: 50%"
                />
                <!-- <v-btn
                  icon
                  :style="detail2.favorite == 'yes' && 'color: orange'"
                  @click="favoriteClick(detail2.id)"
                  class="style_madi_star_n shadow"
                >
                  <v-icon>mdi-star</v-icon>
                </v-btn> -->
              </div>
              <div class="col-md-8 p-0">
                <div
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 16px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                >
                  {{ detail2.status }}
                </div>
                <!-- <b-form-select
                  v-model="detail2.status"
                  :options="statusItems"
                  size="sm"
                  @change="bulkActionProceed_singel($event, detail2.id)"
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 26px 2px 2px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                ></b-form-select> -->
              </div>
              <div class="col-md-12 p-0 mt-5">
                <h4
                  class="mb-0"
                  style="color: #242424; font-size: 18px; font-weight: bold"
                >
                  {{ detail2.recruiter_profile.company_name }}
                </h4>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 14px">
                  Applied for {{ detail2.job.job_title }}
                </p>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 11px">
                  applied:
                  {{ moment(detail2.job.created_at).format("DD MMM, YY. hh:mmA") }}
                </p>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div class="_btn_gridddd p-0 m-0">
                <div class="p-0" @click="view_CV(detail2.cv_path)">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">View CV</span>
                  </button>
                </div>
                <div class="p-0" @click="downloadCV(detail2.cv_path)" style="">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">Download CV</span>
                  </button>
                </div>
                <div class="p-0" @click="askUserAboutDelete(detail2)">
                  <button
                    type="button"
                    class="new_details_job_dashbord_list2"
                    style="
                      background: rgba(147, 6, 6, 0.05) !important;
                      border-color: rgba(147, 6, 6, 0.5) !important;
                    "
                  >
                    <img
                      class="dashbord"
                      src="\images/job_application/Delete.svg"
                      alt=""
                      width="16"
                      height="16"
                    />
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div
                class="
                  mb-3
                  mt-0
                  mx-0
                  p-0
                  col-md-12
                  d-flex
                  justify-content-center
                "
                style="gap: 5px"
              >
                <div class="p-0">
                  <button
                    v-on:click="singleDetail11(detail2)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Video_icon_.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Video</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail22(detail2)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Audio_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Audio</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail4(detail2)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Q&A_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Q/A</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="
                      singleDetail3(detail2),
                        msg_notification_Bulk(detail2),
                        (detail2.msgs_counts = 0)
                    "
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Conversations_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Chat</div>
                    <span
                      class=""
                      style="
                        position: absolute;
                        top: -8px;
                        right: -15%;
                        background-color: #e80000 !important;
                        color: white !important;
                        border-radius: 50px;
                        width: 16px;
                        height: 16px;
                      "
                      v-if="detail2.msgs_counts > 0"
                      >{{ detail2.msgs_counts }}</span
                    >
                  </button>
                </div>
                <div class="p-0">
                  <button v-on:click="singleDetail5(detail2)" type="button" class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  ">
                    <img class="dashbord25" src="\images/job_application/Notes.svg" alt="" width="25" height="25" />
                    <div class="light_frozi">Notes</div>
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0"
                style="background: rgba(53, 162, 229, 0.25)"
              />
            </div>
          </div>
          <div
            class="
              col-md-12
              forvideoFullW
              row
              m-0
              border-b-lr-16
              bg-info-new
              pt-0
            "
          >
            <h5
              class="p-0 mb-4"
              style="
                font-size: 26px;
                color: #005696 !important;
                font-weight: bold;
              "
            >
              Audio introduction
            </h5>
            <video-player
              class="video-player-box video_by_ch2 p-0"
              ref="videoPlayer1"
              :options="detail2.videoPlayer1"
              :playsinline="true"
              customEventName="customstatechangedeventname"
            >
            </video-player>
          </div>
        </div>
      </div>
      <!-- sidbar_ch_new2 for stucky -->
      <div class="col-lg-4 p-0" v-if="detail3">
        <div class="col-lg-12 pl-0 pr-0">
          <div class="col-md-12 row m-0 p-0">
            <div
              class="col-md-12 row m-0 border-t-lr-16 bg-info-new pb-0"
              :id="
                'jobseeker_app_' +
                  detail3.recruiter_profile.company_name
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '_' +
                  detail3.job.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
              "
            >
              <div class="col-md-12 p-0 text-end">
                <button
                  class="badge badge-danger badge-pill"
                  @click="(detail3 = false), (alwyes = true)"
                >
                  X
                </button>
              </div>
              <div class="col-md-4 p-0" style="position: relative">
                <img
                  @error="onImageLoadFailure($event)"
                  :src="mediaUrl + detail3.recruiter_profile.profile_pic || ''"
                  alt="Profile Image"
                  style="width: 74px; height: 74px; border-radius: 50%"
                />
                <!-- <v-btn
                  icon
                  :style="detail3.favorite == 'yes' && 'color: orange'"
                  @click="favoriteClick(detail3.id)"
                  class="style_madi_star_n shadow"
                >
                  <v-icon>mdi-star</v-icon>
                </v-btn> -->
              </div>
              <div class="col-md-8 p-0">
                <div
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 16px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                >
                  {{ detail3.status }}
                </div>
                <!-- <b-form-select
                  v-model="detail3.status"
                  :options="statusItems"
                  size="sm"
                  @change="bulkActionProceed_singel($event, detail3.id)"
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 26px 2px 2px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                ></b-form-select> -->
              </div>
              <div class="col-md-12 p-0 mt-5">
                <h4
                  class="mb-0"
                  style="color: #242424; font-size: 18px; font-weight: bold"
                >
                  {{ detail3.recruiter_profile.company_name }}
                </h4>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 14px">
                  Applied for {{ detail3.job.job_title }}
                </p>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 11px">
                  applied:
                  {{ moment(detail3.job.created_at).format("DD MMM, YY. hh:mmA") }}
                </p>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div class="_btn_gridddd p-0 m-0">
                <div class="p-0" @click="view_CV(detail3.cv_path)">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">View CV</span>
                  </button>
                </div>
                <div class="p-0" @click="downloadCV(detail3.cv_path)" style="">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">Download CV</span>
                  </button>
                </div>
                <div class="p-0" @click="askUserAboutDelete(detail3)">
                  <button
                    type="button"
                    class="new_details_job_dashbord_list2"
                    style="
                      background: rgba(147, 6, 6, 0.05) !important;
                      border-color: rgba(147, 6, 6, 0.5) !important;
                    "
                  >
                    <img
                      class="dashbord"
                      src="\images/job_application/Delete.svg"
                      alt=""
                      width="16"
                      height="16"
                    />
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div
                class="
                  mb-3
                  mt-0
                  mx-0
                  p-0
                  col-md-12
                  d-flex
                  justify-content-center
                "
                style="gap: 5px"
              >
                <div class="p-0">
                  <button
                    v-on:click="singleDetail11(detail3)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Video_icon_.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Video</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail22(detail3)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Audio_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Audio</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail4(detail3)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Q&A_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Q/A</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="
                      singleDetail3(detail3),
                        msg_notification_Bulk(detail3),
                        (detail3.msgs_counts = 0)
                    "
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Conversations_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Chat</div>
                    <span
                      class=""
                      style="
                        position: absolute;
                        top: -8px;
                        right: -15%;
                        background-color: #e80000 !important;
                        color: white !important;
                        border-radius: 50px;
                        width: 16px;
                        height: 16px;
                      "
                      v-if="detail3.msgs_counts > 0"
                      >{{ detail3.msgs_counts }}</span
                    >
                  </button>
                </div>
                <div class="p-0">
                  <button v-on:click="singleDetail5(detail3)" type="button" class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  ">
                    <img class="dashbord25" src="\images/job_application/Notes.svg" alt="" width="25" height="25" />
                    <div class="light_frozi">Notes</div>
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0"
                style="background: rgba(53, 162, 229, 0.25)"
              />
            </div>
          </div>
          <div
            class="
              col-md-12
              forvideoFullW
              row
              m-0
              border-b-lr-16
              bg-info-new
              pt-0
            "
          >
            <h5
              class="p-0 mb-4"
              style="
                font-size: 26px;
                color: #005696 !important;
                font-weight: bold;
              "
            >
              Massges
            </h5>
            <div class="col-12 chat_box_whit_new_styleCH">
              <!-- Massges setting start -->
              <div
                class="chat_box_whit_new_styleCH_child"
                id="chat_box_secroll"
              >
                <div v-if="!messages.length" class="chat_is_not_avilable">
                  <img src="\images/NoMessages.png" alt="No Messages icon" />
                  <h6 style="font-size: 20px; font-weight: 600">
                    No Messages!
                  </h6>
                  <h6>Send a message to start a conversation.</h6>
                </div>
                <div
                  v-for="(_item, _i) in messages"
                  :key="_i"
                  :class="
                    user.id == _item.sender_id ? 'Me_side_msg' : 'you_side_msg'
                  "
                >
                  <div
                    v-if="detail3.recruiter_profile"
                    class="profile_img_chat"
                  >
                    <img
                      @error="onImageLoadFailure($event)"
                      :src="
                        mediaUrl + detail3.recruiter_profile.profile_pic || ''
                      "
                      width="23"
                      v-if="user.id !== _item.sender_id"
                    />
                  </div>
                  <div class="chatBox">
                    <p class="m-0"><span v-html="_item.message"> </span></p>
                  </div>
                  <p class="msgTime">
                    {{
                      moment(_item.created_at).format("DD MMMM, YYYY hh:mm A")
                    }}
                  </p>
                </div>
              </div>
              <div
                class="row p-0 m-0 col-md-12 chat_box_ch"
                style="position: sticky; background: white"
                v-if="msg_limat_var()"
              >
                <div class="col-12 p-0">
                  <div class="chat-box-tray row col-12 p-0 m-0">
                    <div class="col-10 p-0">
                      <input
                        type="text"
                        required
                        placeholder="Type your message here..."
                        v-model="message"
                        v-on:keyup.enter="sendMsg(detail3)"
                      />
                    </div>
                    <div class="col-1 p-0 position-relative">
                      <v-file-input
                        class="slect_box_by_ch"
                        @change="Preview_image"
                        v-model="file"
                      >
                      </v-file-input>
                    </div>
                    <div class="col-1 p-0">
                      <i class="material-icons" @click="sendMsg(detail3)"
                        >send</i
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row p-0 m-0 col-md-12 chat_box_ch"
                style="
                  position: sticky;
                  background: white;
                  pointer-events: none;
                  opacity: 0.4;
                "
                v-if="!msg_limat_var()"
              >
                <div class="col-12 p-0">
                  <div class="chat-box-tray row col-12 p-0 m-0">
                    <div class="col-10 p-0">
                      <input
                        type="text"
                        required
                        placeholder="Type your message here..."
                        v-model="message"
                      />
                    </div>
                    <div class="col-1 p-0 position-relative">
                      <v-file-input class="slect_box_by_ch" v-model="file">
                      </v-file-input>
                    </div>
                    <div class="col-1 p-0">
                      <i class="material-icons">send</i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 p-0" v-if="detail4">
        <div class="col-lg-12 pl-0 pr-0">
          <div class="col-md-12 row m-0 p-0">
            <div
              class="col-md-12 row m-0 border-t-lr-16 bg-info-new pb-0"
              :id="
                'jobseeker_app_' +
                  detail4.recruiter_profile.company_name
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '_' +
                  detail4.job.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
              "
            >
              <div class="col-md-12 p-0 text-end">
                <button
                  class="badge badge-danger badge-pill"
                  @click="(detail4 = false), (alwyes = true)"
                >
                  X
                </button>
              </div>
              <div class="col-md-4 p-0" style="position: relative">
                <img
                  @error="onImageLoadFailure($event)"
                  :src="mediaUrl + detail4.recruiter_profile.profile_pic || ''"
                  alt="Profile Image"
                  style="width: 74px; height: 74px; border-radius: 50%"
                />
                
              </div>
              <div class="col-md-8 p-0">
                <div
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 16px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                >
                  {{ detail4.status }}
                </div>
                
              </div>
              <div class="col-md-12 p-0 mt-5">
                <h4
                  class="mb-0"
                  style="color: #242424; font-size: 18px; font-weight: bold"
                >
                  {{ detail4.recruiter_profile.company_name }}
                </h4>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 14px">
                  Applied for {{ detail4.job.job_title }}
                </p>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 11px">
                  applied:
                  {{ moment(detail4.job.created_at).format("DD MMM, YY. hh:mmA") }}
                </p>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div class="_btn_gridddd p-0 m-0">
                <div class="p-0" @click="view_CV(detail4.cv_path)">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">View CV</span>
                  </button>
                </div>
                <div class="p-0" @click="downloadCV(detail4.cv_path)" style="">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">Download CV</span>
                  </button>
                </div>
                <div class="p-0" @click="askUserAboutDelete(detail4)">
                  <button
                    type="button"
                    class="new_details_job_dashbord_list2"
                    style="
                      background: rgba(147, 6, 6, 0.05) !important;
                      border-color: rgba(147, 6, 6, 0.5) !important;
                    "
                  >
                    <img
                      class="dashbord"
                      src="\images/job_application/Delete.svg"
                      alt=""
                      width="16"
                      height="16"
                    />
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div
                class="
                  mb-3
                  mt-0
                  mx-0
                  p-0
                  col-md-12
                  d-flex
                  justify-content-center
                "
                style="gap: 5px"
              >
                <div class="p-0">
                  <button
                    v-on:click="singleDetail11(detail4)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Video_icon_.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Video</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail22(detail4)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Audio_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Audio</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail4(detail4)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Q&A_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Q/A</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="
                      singleDetail3(detail4),
                        msg_notification_Bulk(detail4),
                        (detail4.msgs_counts = 0)
                    "
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Conversations_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Chat</div>
                    <span
                      class=""
                      style="
                        position: absolute;
                        top: -8px;
                        right: -15%;
                        background-color: #e80000 !important;
                        color: white !important;
                        border-radius: 50px;
                        width: 16px;
                        height: 16px;
                      "
                      v-if="detail4.msgs_counts > 0"
                      >{{ detail4.msgs_counts }}</span
                    >
                  </button>
                </div>
                <div class="p-0">
                  <button v-on:click="singleDetail5(detail4)" type="button" class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  ">
                    <img class="dashbord25" src="\images/job_application/Notes.svg" alt="" width="25" height="25" />
                    <div class="light_frozi">Notes</div>
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0"
                style="background: rgba(53, 162, 229, 0.25)"
              />
            </div>
          </div>
          <div
            class="
              col-md-12
              forvideoFullW
              row
              m-0
              border-b-lr-16
              bg-info-new
              pt-0
            "
          >
            <h5
              class="p-0 mb-4"
              style="
                font-size: 26px;
                color: #005696 !important;
                font-weight: bold;
              "
            >
              Answer Questions
            </h5>
            <div class="col-12 p-0">
              <div v-for="(detail4, i) in detail4.answered_questions" :key="i">
                <span
                  ><b>Question #{{ i + 1 }}:</b> {{ detail4.question }}</span
                ><br />
                <span v-if="detail4.type == 'multi'">
                  <b> Aanswer:</b>
                  {{ JSON.parse(detail4.answer).toString() }}
                </span>
                <span v-if="detail4.type != 'multi'">
                  <b> Answer:</b> {{ detail4.answer }} </span
                ><br /><br />
              </div>
              <div
                class="qa text-center"
                style="font-size: 20px"
                v-if="!detail4.answered_questions.length"
              >
                No questions were asked by recruiter
              </div>
            </div>
          </div>
        </div>
        <!--end col-->
      </div>
      <div class="col-lg-4 p-0" v-if="detail5">
        <div class="col-lg-12 pl-0 pr-0">
          <div class="col-md-12 row m-0 p-0">
            <div
              class="col-md-12 row m-0 border-t-lr-16 bg-info-new pb-0"
              :id="
                'jobseeker_app_' +
                  detail5.recruiter_profile.company_name
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '') +
                  '_' +
                  detail5.job.job_title
                    .toLowerCase()
                    .replace(/ /g, '-')
                    .replace(/[^\w-]+/g, '')
              "
            >
              <div class="col-md-12 p-0 text-end">
                <button
                  class="badge badge-danger badge-pill"
                  @click="(detail5 = false), (alwyes = true)"
                >
                  X
                </button>
              </div>
              <div class="col-md-4 p-0" style="position: relative">
                <img
                  @error="onImageLoadFailure($event)"
                  :src="mediaUrl + detail5.recruiter_profile.profile_pic || ''"
                  alt="Profile Image"
                  style="width: 74px; height: 74px; border-radius: 50%"
                />
                
              </div>
              <div class="col-md-8 p-0">
                <div
                  style="
                    border: 1.5px solid rgb(53, 162, 229);
                    font-size: 12px;
                    padding: 2px 16px;
                    border-radius: 4px;
                    color: rgb(53, 162, 229);
                    width: fit-content;
                    position: absolute;
                    right: 0px;
                    top: 20px;
                    text-align: center;
                    background-color: transparent;
                  "
                >
                  {{ detail5.status }}
                </div>
                
              </div>
              <div class="col-md-12 p-0 mt-5">
                <h4
                  class="mb-0"
                  style="color: #242424; font-size: 18px; font-weight: bold"
                >
                  {{ detail5.recruiter_profile.company_name }}
                </h4>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 14px">
                  Applied for {{ detail5.job.job_title }}
                </p>
              </div>
              <div class="col-md-12 p-0">
                <p class="m-0" style="color: #666; font-size: 11px">
                  applied:
                  {{ moment(detail5.job.created_at).format("DD MMM, YY. hh:mmA") }}
                </p>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div class="_btn_gridddd p-0 m-0">
                <div class="p-0" @click="view_CV(detail5.cv_path)">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">View CV</span>
                  </button>
                </div>
                <div class="p-0" @click="downloadCV(detail5.cv_path)" style="">
                  <button type="button" class="new_details_job_dashbord_list2">
                    <span class="v-btn__content">Download CV</span>
                  </button>
                </div>
                <div class="p-0" @click="askUserAboutDelete(detail5)">
                  <button
                    type="button"
                    class="new_details_job_dashbord_list2"
                    style="
                      background: rgba(147, 6, 6, 0.05) !important;
                      border-color: rgba(147, 6, 6, 0.5) !important;
                    "
                  >
                    <img
                      class="dashbord"
                      src="\images/job_application/Delete.svg"
                      alt=""
                      width="16"
                      height="16"
                    />
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0 mt-3"
                style="background: rgba(53, 162, 229, 0.25)"
              />
              <div
                class="
                  mb-3
                  mt-0
                  mx-0
                  p-0
                  col-md-12
                  d-flex
                  justify-content-center
                "
                style="gap: 5px"
              >
                <div class="p-0">
                  <button
                    v-on:click="singleDetail11(detail5)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Video_icon_.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Video</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail22(detail5)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Audio_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Audio</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="singleDetail4(detail5)"
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Q&A_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Q/A</div>
                  </button>
                </div>
                <div class="p-0">
                  <button
                    v-on:click="
                      singleDetail3(detail5),
                        msg_notification_Bulk(detail5),
                        (detail5.msgs_counts = 0)
                    "
                    type="button"
                    class="
                      btn_dash_ch__
                      btn_span_ch
                      new_details_job_dashbord_list
                    "
                  >
                    <img
                      class="dashbord25"
                      src="\images/job_application/Conversations_icon_normal.svg"
                      alt=""
                      width="25"
                      height="25"
                    />
                    <div class="light_frozi">Chat</div>
                    <span
                      class=""
                      style="
                        position: absolute;
                        top: -8px;
                        right: -15%;
                        background-color: #e80000 !important;
                        color: white !important;
                        border-radius: 50px;
                        width: 16px;
                        height: 16px;
                      "
                      v-if="detail5.msgs_counts > 0"
                      >{{ detail5.msgs_counts }}</span
                    >
                  </button>
                </div>
                <div class="p-0">
                  <button v-on:click="singleDetail5(detail5)" type="button" class="
                    btn_dash_ch__
                    btn_span_ch
                    new_details_job_dashbord_list
                  ">
                    <img class="dashbord25" src="\images/job_application/Notes.svg" alt="" width="25" height="25" />
                    <div class="light_frozi">Notes</div>
                  </button>
                </div>
              </div>
              <hr
                class="col-md-12 p-0"
                style="background: rgba(53, 162, 229, 0.25)"
              />
            </div>
          </div>
          <div class="
              col-md-12
              forvideoFullW
              row
              m-0
              border-b-lr-16
              bg-info-new
              pt-0
            ">
            <h5 class="p-0 mb-4" style="
                font-size: 26px;
                color: #005696 !important;
                font-weight: bold;
              ">
              Notes
            </h5>
            <!-- ???????????????????????????????????????????? -->
            <div class="card card-custom card-stretch bg-info-new rounded py-0 px-2">
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table table-borderless table-vertical-center">
                    <thead>
                      <tr>
                        <th class="p-0"></th>
                        <th class="p-0" tyle="max-width: 30px"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(item, i) in detail5.notejobseeker">
                        <tr v-bind:key="i">
                          <td class="pl-0">
                            <a class="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg">{{
                            item.title }}</a>
                            <span class="text-muted font-weight-bold d-block" style="font-size: 12px;">
                              {{ moment(item.created_at).format("DD MMM, YY. hh:mmA") }}
                            </span>
                          </td>
                          <td class="text-right pr-0"
                            style="max-width: 75px !important;min-width: 75px !important;width: 75px !important;">
                            <a @click="edit_note(item)" class="btn btn-icon btn-light btn-sm">
                              <span class="svg-icon svg-icon-md svg-icon-success">
                                <img class="" src="\images/job_application/Edit_icon.svg" alt="" width="18"
                                  height="18" />
                              </span>
                            </a>
                            <a @click="delete_note(detail5,item)" class="btn btn-icon btn-light btn-sm ml-1">
                              <span class="svg-icon svg-icon-md svg-icon-success">
                                <img class="" src="\images/job_application/Delete.svg" alt="" width="18" height="18" />
                              </span>
                            </a>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <textarea placeholder="Please add your Note here" v-model="Notetitle" :rules="titleRules" required
                      class="form-control text_era_note_title" id="exampleFormControlTextarea1" rows="3"></textarea>
                    <a @click="add_note(detail5)" class="btn btn-icon add_note_btn_ch">
                      {{Note_btn}}
                    </a>
                    <a @click="cancel_note()" style="background: rgb(147 6 6) !important;"
                      class="btn btn-icon add_note_btn_ch ml-2">
                      Cancel
                    </a>
                  </v-form>
                </div>
              </div>
            </div>
            <!-- ??????????????????????????????????????????// -->
          </div>
        </div>
      </div>
      <div class="col-lg-4 p-0 alwyes" v-if="alwyes">
        <div class="col-lg-12 pl-0 pr-0">
          <div class="card sidebar">
            <div class="card-body widget cardbodych" style="">
              <h5
                class=""
                style="
                  font-style: normal;
                  font-weight: 700 !important;
                  font-size: 30px;
                  line-height: 120%;
                  color: #005696;
                "
              >
          Advertise with  <br />
          job4u.pk
          </h5>
        </div>
        <div class="col-12">
          <p
            style="
                        font-style: normal;
                        font-weight: 400;
                        font-size: 18px;
                        line-height: 140%;
                        color: #666666;
                        background: transparent !important;
                      "
          >
          Contact us to display your
          Ad here to reach tens of
          thousands of people!

          </p>
              <button
                style="
                  padding: 12px 16px;
                  gap: 8px;
                  background: #35a2e5;
                  border-radius: 53px;
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 140%;
                  color: #ffffff;
                "
              >
              <img
              class="dashbord123"
              src="\images/job_application/Call.svg"
              alt=""
              style="margin-right: 10px"
            />
              Contact Sales
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirm Delete Item -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="380px">
        <v-card>
          <v-card-title>
            <span class="headline"
              >Do you really want to DELETE this item?</span
            >
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="custom-submit-button" text @click="dialog = false"
              >No</v-btn
            >
            <v-btn class="custom-cancel-button" text @click="deleteItem"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Send Message Popup -->
    <v-row justify="center">
      <v-dialog
        v-model="sendMsgPopup"
        persistent
        max-width="600px"
        style="overflow-x: hidden"
      >
        <v-card>
          <v-card-title>
            <span class="headline">Send direct message</span>
          </v-card-title>
          <div class="row" style="padding-left: 6%; padding-right: 6%">
            <div class="col-md-12">
              <v-text-field
                v-model="message_title"
                label="Subject"
              ></v-text-field>

              <v-file-input
                style="font-size: 8px"
                label="file"
                @change="Preview_image"
                v-model="file"
              >
              </v-file-input>
            </div>

            <label>Message</label>
            <vue-editor
              style="width: 100%; height: 80%"
              v-model="message"
            ></vue-editor>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              class="custom-submit-button"
              text
              @click="sendMsgPopup = false"
              >Cancel</v-btn
            >
            <v-btn class="custom-cancel-button" text @click="sendMsg"
              ><b-spinner small type="grow" v-if="deleting"></b-spinner
              >Send</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
import Swal from "sweetalert2";
import JobSeekerService from "@/MainServices/JobSeekerService.js";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import { VueEditor } from "vue2-editor";
import moment from "moment";

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      profile: JSON.parse(localStorage.getItem("profile")),
      mediaUrl: MEDIA_URL,
      statusItems: [
        "All",
        "Applied",
        "Shorlisted",
        "Call For Interview",
        "interviewed",
        "Selected",
      ],
      filter: "",
      thisJobId: 0,
      iD_rout: '',
      search: "",
      loading: true,
      dialog: false,
      deleteId: null,
      deleting: false,
      success: false,
      token: `Bearer ${localStorage.getItem("token")}`,
      valid: true,

      headers: [
        { text: "COMPANY", value: "name" },
        { text: "JOB TITLE", value: "title" },
        { text: "STATUS", value: "status" },
        { text: "ACTIONS", value: "action" },
      ],
      data: [],
      originalData: [],
      bulkActionArr: [],
      activeVideo: "",
      sendMsgPopup: false,
      msgUser: null,
      message_title: "",
      message: "",
      file: null,
      file_url: null,
      jobId: null,
      conversation: [],
      messages: [],
      msg_limat: "",
      msg_limat2: "",
      filter_tital: "",
      filter_jobsekeer: "",
      job_titals: ["All"],
      job_jobsekeer: ["All"],
      detail1: null,
      detail2: null,
      detail3: null,
      detail4: null,
      alwyes: true,
      Notetitle: null,
      Note_id: null,
      Note_btn: "Add Note",
      data_Filter: [],
      detail5: null,
      titleRules: [
        (v) => !!v || "Title is required",
        (v) => (v && v.length <= 25) || "Title must be less than 25 characters",
      ],
    };
  },
  mounted() {
    if (window.location.search) {
      this.iD_rout = window.location.search.replace("?", "");
    }
    window.Echo.channel("channel").listen("Notifications", (e) => {
      var thisUser = false;

      for (let index = 0; index < e.threads.length; index++) {
        if (
          this.thisJobId == e.threads[index].job_id &&
          (e.seeker_id == e.threads[index].receiver_id ||
            e.seeker_id == e.threads[index].sender_id)
        ) {
          thisUser = true;
          break;
        }
      }

      if (thisUser == true) {
        this.conversation = [];
        this.messages = [];
        let messages = [];
        e.inbox.map((data) => data.map((msg) => messages.push(msg)));
        messages = messages.sort((msg1, msg2) =>
          moment(msg1.created_at)
            .format("X")
            .localeCompare(moment(msg2.created_at).format("X"))
        );
        // .reverse();
        this.conversation = e;
        this.messages = messages;
      }
    });

    var link = !!document.querySelector("link[rel='canonical']")
      ? document.querySelector("link[rel='canonical']")
      : document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute(
      "href",
      location.protocol + "//" + location.host + location.pathname
    );
    document.head.appendChild(link);
    this.getInititalData();
  },
  components: {
    videoPlayer,
    VueEditor,
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  methods: {
    edit_note(item) {
      this.Note_id = item.id;
      this.Notetitle = item.title;
      this.Note_btn = "Update Note"
    },
    delete_note(item5, item) {
      this.Note_id = item.id;
      this.Notetitle = null;
      axios.defaults.headers.common["Authorization"] = this.token;
      axios
        .post(`${API_URL}/add-note-jobseeker`, {
          app_conn_id: item5.id,
          note_id: this.Note_id,
          title: this.Notetitle,
        })
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data.msg,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.detail5.notejobseeker = res.data.notejobseeker;
            this.cancel_note();
        });
    },
    cancel_note() {
      this.Note_id = null;
      this.Notetitle = null;
      this.Note_btn = "Add Note"
    },
    add_note(item5) {
      if (this.Notetitle) {
        axios.defaults.headers.common["Authorization"] = this.token;
        axios
          .post(`${API_URL}/add-note-jobseeker`, {
            app_conn_id: item5.id,
            note_id: this.Note_id,
            title: this.Notetitle,
          })
          .then((res) => {
            Swal.fire({
              title: "",
              text: res.data.msg,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.detail5.notejobseeker = res.data.notejobseeker;
            this.cancel_note();
          });
      } else {
        Swal.fire({
          title: "",
          text: "Please add Note",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },
    msg_notification_Bulk(item) {
      let ids = item.job.threads;
      if (ids.length) {
        var count_threds = [];
        ids.forEach((element) => {
          count_threds.push(element.id);
        });
        let receiver_id = this.profile.user_id;
        axios.defaults.headers.common["Authorization"] = this.token;
        axios
          .post(`${API_URL}/msg-notifications-Bulk`, {
            id: count_threds,
            receiver_id: receiver_id,
          })
          .then((res) => {});
      }
    },
    moment: function(item) {
      if (item) {
        return moment(String(item));
      }
    },
    onImageLoadFailure(event) {
      event.target.src = "../images/profile_ch.jpg";
    },
    getInititalData() {
      JobSeekerService.getJobApplications()
        .then((res) => {
          this.loading = false;
          var temp = [];
          res.data.forEach((element) => {
            this.job_titals.push(element.job.job_title);
            this.job_jobsekeer.push(element.recruiter_profile.company_name);
            element.videoPlayer1 = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "audio/wav",
                  src: this.mediaUrl + "videos/raw/" + element.intro_audio,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            element.videoPlayer = {
              // videojs options
              muted: true,
              language: "en",
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [
                {
                  type: "video/mp4",
                  src: this.mediaUrl + "/videos/raw/" + element.intro_video,
                },
              ],
              poster: "/static/images/author.jpg",
            };
            var msgs_counts = 0;

            element.job.threads.map((el) => {
              el.msgs.map((e) => {
                if (
                  e.receiver_id == this.profile.user_id &&
                  e.seen_at == null
                ) {
                  msgs_counts++;
                }
              });
            });
            element.msgs_counts = msgs_counts;
            // temp.push(element);
            temp.push(element);
          });
          this.data = temp;
          this.originalData = temp;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    favoriteClick(id) {
      RecruiterService.changeJobApplicationFavoriteStatus(id)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.getInititalData();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    singleDetail1(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.detail5 = false;
      this.alwyes = false;
      this.iD_rout = "";
    },
    singleDetail11(item) {
      this.detail1 = item;
      this.detail2 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.detail5 = false;
      this.alwyes = false;
    },
    singleDetail2(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.detail5 = false;
      this.alwyes = false;
    },
    singleDetail22(item) {
      this.detail2 = item;
      this.detail1 = false;
      this.detail3 = false;
      this.detail4 = false;
      this.detail5 = false;
      this.alwyes = false;
    },
    singleDetail3(item) {
      this.detail3 = item;
      this.getConversation(item);
      this.detail2 = false;
      this.detail1 = false;
      this.detail4 = false;
      this.detail5 = false;
      this.alwyes = false;
    },
    singleDetail4(item) {
      this.detail4 = item;
      this.detail5 = false;
      this.detail2 = false;
      this.detail3 = false;
      this.detail1 = false;
      this.alwyes = false;
    },
    singleDetail5(item) {
      this.detail5 = item;
      this.detail4 = false;
      this.detail2 = false;
      this.detail3 = false;
      this.detail1 = false;
      this.alwyes = false;
    },
    filterData() {
      var temp = [];
      var val = this.filter;
      if (val == "All") {
        this.data = this.originalData;
      } else {
        this.originalData.forEach((element) => {
          if (element.status == val) {
            temp.push(element);
          }
        });
        this.data = temp;
      }
    },
    clearFilter() {
      this.filter = "";
      this.filter_jobsekeer = "";
      this.filter_tital = "";
      this.getInititalData();
    },
    filterbyjobsekeer(val) {
      if (val == "All") {
        this.data = this.originalData;
      } else {
        this.data = this.originalData.filter((element) =>
          element.recruiter_profile.company_name
            .toLowerCase()
            .includes(val.toLowerCase())
        );
      }
    },
    filtertital(val) {
      if (val == "All") {
        this.data = this.originalData;
      } else {
        this.data = this.originalData.filter((element) =>
          element.job.job_title.toLowerCase().includes(val.toLowerCase())
        );
      }
    },
    bulkAction(event, id) {
      var newArr = [];
      if (event == true) {
        newArr.push(id);
        this.bulkActionArr = newArr;
      } else {
        newArr = this.bulkActionArr.filter((item) => {
          return item !== id;
        });
        this.bulkActionArr = newArr;
      }
    },

    bulkActionProceed(val) {
      if (val !== "All") {
        RecruiterService.changeJobApplicationStatus({
          ids: this.bulkActionArr,
          status: val,
        })
          .then((res) => {
            Swal.fire({
              title: "",
              text: res.data,
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.getInititalData();
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    downloadCV(path) {
      if (path) {
        window.open(this.mediaUrl + path, "_blank");
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available. Please Add your CV.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },
    view_CV(path) {
      if (path) {
        // window.open("/cv-view?path=" + path.replace(/\//g, "-"), "_blank");
        https: window.open(
          "https://docs.google.com/gview?url=" +
            this.mediaUrl +
            path +
            "&embedded=true",
          "_blank"
        );
      } else {
        Swal.fire({
          title: "",
          text: "No CV is available. Please Add your CV.",
          icon: "success",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },

    withdrawApplication(id) {
      JobSeekerService.withdrawJobApplication(id)
        .then((res) => {
          Swal.fire({
            title: "",
            text: res.data,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false,
          });
          this.dialog = false;
          this.loading = false;
          this.success = true;
          this.submitting = false;
          this.getInititalData();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },

    deleteItem() {
      this.withdrawApplication(this.deleteId);
    },

    Preview_image() {
      this.file_url = this.file;
    },

    sendMsgPopupHandler(item) {
      this.sendMsgPopup = true;
      this.msgUser = item.recruiter_id;
      this.jobId = item.job_id;
      this.job_app_id = item.id;
    },

    resetSendMsg() {
      this.msgUser = null;
      this.message_title = "";
      this.message = "";
      this.file = null;
      this.file_url = null;
      this.sendMsgPopup = false;
      this.jobId = null;
      setTimeout(() => {
        this.chat_to_bottom();
      }, 100);
    },

    sendMsg(item) {
      this.msgUser = item.recruiter_id;
      this.jobId = item.job_id;
      this.job_app_id = item.id;
      let formData = new FormData();
      formData.append("message_title", this.message_title);
      formData.append("job_id", this.jobId);
      formData.append("message", this.message);
      formData.append("receiver_id", this.msgUser);
      formData.append("file", this.file_url);
      formData.append("job_app_id", this.job_app_id);

      axios.defaults.headers.common["Authorization"] = this.token;
      axios.post(`${API_URL}/send-message`, formData).then((res) => {
        // Swal.fire({
        //   title: "",
        //   text: res.data,
        //   icon: "success",
        //   confirmButtonClass: "btn btn-secondary",
        //   heightAuto: false,
        // });
        this.getInititalData();
        this.resetSendMsg();
      });
    },
    msg_limat_var() {
      if (this.messages.length > 0) {
        var last = this.messages[this.messages.length - 1].sender_id;
        var send_last = this.messages[this.messages.length - 2].sender_id;
        if (last == this.profile.user_id && send_last == this.profile.user_id) {
          return false;
        }
        return true;
      } else {
        return true;
      }
    },
    secrollottom() {
      var container_box = document.getElementById("chat_box_secroll");
      container_box.scrollTop = container_box.offsetHeight;
      console.log("container_box", container_box);
    },
    getConversation(item) {
      this.thisJobId = item.job_id;
      this.messages = [];
      JobSeekerService.getConversations(item.job_id).then((res) => {
        const messages = [];
        res.data.map((conversation) =>
          conversation.messages.map((msg) => messages.push(msg))
        );
        messages.sort((msg1, msg2) =>
          moment(msg1.created_at)
            .format("X")
            .localeCompare(moment(msg2.created_at).format("X"))
        );
        this.conversation = res.data;
        this.messages = messages;
        setTimeout(() => {
          this.chat_to_bottom();
        }, 100);
      });
    },
    chat_to_bottom() {
      $(".chat_box_whit_new_styleCH_child").scrollTop(
        $(".chat_box_whit_new_styleCH_child")[0].scrollHeight
      );
    },
  },
};
</script>
<style scoped>
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
</style>
